import React, { createContext, useCallback, useContext, useRef } from 'react';
import debounce from 'lodash/debounce';
import { noop } from '../../../utils/noop';
import { ScrollingUtils } from '../../../utils/scrolling.utils';
var ScrollingToHigherItemContext = createContext({
    addItem: noop,
});
var ScrollingToHigherItemContextProvider = ScrollingToHigherItemContext.Provider;
export function useScrollingToHigherItem() {
    var addItem = useContext(ScrollingToHigherItemContext).addItem;
    return addItem;
}
var TIME_TO_FLUSH_ITEMS = 50;
var SCROLLING_OFFSET = 40;
export var ScrollingToHigherItemProvider = function (props) {
    var itemRefs = useRef([]);
    var flushItems = useCallback(debounce(function (passedItemRefs) {
        var positions = passedItemRefs.current.map(function (el) {
            return ScrollingUtils.getYPosOnPage(el);
        });
        var higherItemYPos = Math.min.apply([], positions);
        var scrollTo = higherItemYPos - SCROLLING_OFFSET;
        if (!ScrollingUtils.isYPosVisible(scrollTo)) {
            ScrollingUtils.smoothScrollTo(scrollTo);
        }
        passedItemRefs.current = [];
    }, TIME_TO_FLUSH_ITEMS), []);
    var addItem = useCallback(function (newItem) {
        itemRefs.current.push(newItem);
        flushItems(itemRefs);
    }, [itemRefs]);
    return (React.createElement(ScrollingToHigherItemContextProvider, { value: { addItem: addItem } }, props.children));
};
